import { DemappingRptConstants } from "../constants/DemappingRptConstants";

export function DemappingRpt(state = {}, action) {
    switch (action.type) {
        case DemappingRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case DemappingRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case DemappingRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case DemappingRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case DemappingRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case DemappingRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case DemappingRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}